import { useCallback, useState } from "react"

export const useImageModal = () => {
  const [openModal, setOpenModal] = useState(false)
  const [activeImage, setActiveImage] = useState()
  const handleClose = useCallback(() => {
    setOpenModal(false)
  }, [])
  const handleImage = useCallback((value) => {
    setActiveImage(value)
    setOpenModal(true)
  }, [])
  return {
    openModal,
    setOpenModal,
    activeImage,
    setActiveImage,
    handleClose,
    handleImage,
  }
}
